export var ActorId;
(function (ActorId) {
    ActorId["ADMIN_COCKPIT"] = "ADMIN_COCKPIT";
    ActorId["AWP"] = "AWP";
    ActorId["COMPASS"] = "COMPASS";
    ActorId["DEALER_COCKPIT"] = "DEALER_COCKPIT";
    ActorId["FEEDBACK_COLLECTION"] = "FEEDBACK_COLLECTION";
    ActorId["FEEDBACK_REVIEW"] = "FEEDBACK_REVIEW";
    ActorId["GENERIC_ACTOR"] = "GENERIC_ACTOR";
    ActorId["INFORMATION_RESEARCH"] = "INFORMATION_RESEARCH";
    ActorId["LEADS_COCKPIT"] = "LEADS_COCKPIT";
    ActorId["PARTS_CATALOGUE"] = "PARTS_CATALOGUE";
    ActorId["PARTS_ORDERING"] = "PARTS_ORDERING";
    ActorId["PRINT_CENTER"] = "PRINT_CENTER";
    ActorId["SERVER"] = "SERVER";
    ActorId["SERVICE_CASE_DETAILS"] = "SERVICE_CASE_DETAILS";
    ActorId["SERVICE_CASE_OVERVIEW"] = "SERVICE_CASE_OVERVIEW";
    ActorId["SERVICE_CONTRACTS"] = "SERVICE_CONTRACTS";
    ActorId["SERVICE_PLANNING"] = "SERVICE_PLANNING";
    ActorId["SERVICE_RIDE"] = "SERVICE_RIDE";
    ActorId["TYPE_CODE"] = "TYPE_CODE";
    ActorId["USER_COCKPIT"] = "USER_COCKPIT";
    ActorId["VEHICLE_DIAGNOSIS"] = "VEHICLE_DIAGNOSIS";
    ActorId["VEHICLE_INFORMATION"] = "VEHICLE_INFORMATION";
    ActorId["WARRANTY_VEHICLE_INQUIRY"] = "WARRANTY_VEHICLE_INQUIRY";
    ActorId["LEADS_CONFIG"] = "LEADS_CONFIG";
})(ActorId || (ActorId = {}));
//# sourceMappingURL=actorId.js.map